/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ReceivedPayment extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default ReceivedPayment;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/receivedPayment.js